import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {FormulaOptions, PreferredReturnType} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {EventManager} from "shared/core/Events/EventManager";
import {CalculateFormula} from "FormBuilder/Events/CalculateFormula";

export class FormulaManager {
    constructor(public FieldModel:FBFieldBaseModel) {
    }


    GetFormula(formulaName:string)
    {
        return this.FieldModel.Options.Formulas.find(x=>x.Name==formulaName)
    }

    UpdateOrCreateFormula(formulaName:string,code:string,compiled:any,preferredReturnType:PreferredReturnType)
    {
        let formula=this.GetFormula(formulaName);
        if(formula==null)
        {
            this.FieldModel.Options.Formulas.push(new FormulaOptions().Merge({Name:formulaName,Code:code,Compiled:compiled,PreferredReturnType:preferredReturnType}))
        }else {
            formula.Code=code;
            formula.Compiled=compiled;
            formula.PreferredReturnType=preferredReturnType;
        }


    }

    HasFormula(FormulaName:string)
    {
        return this.GetFormula(FormulaName)!=null;
    }

    RemoveFormula(FormulaName: string) {
        let formula=this.FieldModel.Options.Formulas.find(x=>x.Name==FormulaName);
        if(formula!=null)
            this.FieldModel.Options.Formulas.splice(this.FieldModel.Options.Formulas.indexOf(formula),1);
    }

    StartListener() {
        for(let formula of this.FieldModel.Options.Formulas)
        {
            for(let fieldUsed of formula.Fields)
            {
                let field=this.FieldModel.FormBuilder.ContainerManager.GetFieldById(fieldUsed,false,true);
                if(field==null) {
                    alert(`Invalid formula for field ${this.FieldModel.Options.Label + ' (Id:' + this.FieldModel.Options.Id}), field with id ${fieldUsed} does not exist`);
                    return;
                }

                field.ValueChanged.Subscribe([this,formula.Name],()=>{
                    this.ExecuteCalculation(formula);
                });
            }

            this.ExecuteCalculation(formula);
        }
    }

    private ExecuteCalculation(formula) {
        let result=EventManager.Publish(new CalculateFormula(this.FieldModel.FormBuilder.ContainerManager.GetFields(false,true,true),formula),0);

        if(typeof this.FieldModel['Set'+formula.Name]!="undefined")
            this.FieldModel['Set'+formula.Name](result);
    }
}